import { NrlkUtilisateur } from "../model/utilisateur.js";
import { NrlkException } from "../model/exception.js";

/**
 * Lecture des données d'un utilisateur par son ID
 * 
 * @param {int} id ID de l'utilisateur
 * 
 * @returns {Promise} Utilisateur
 */
export async function getUtilisateur(id) {
    try {
        // Vérification que le champs ID est bien renseigné et un integer
        if (!id || isNaN(id)) {
            throw new NrlkException("L'ID de l'utilisateur est obligatoire.");
        }

        // Initialisation du model Utilisateur
        const utilisateur = new NrlkUtilisateur(window.entreprise, window.token);

        const data = await utilisateur.getUtilisateur(id);
        return data.data;
    } catch (error) {
        throw new NrlkException(error);
    }
}

/**
 * Lecture de toutes les données des utilisateurs
 * 
 * @returns {Promise} Utilisateurs
 */
export async function getUtilisateurs() {
    try {
        // Initialisation du model Utilisateur
        const utilisateur = new NrlkUtilisateur(window.entreprise, window.token);
        const data = await utilisateur.getUtilisateurs();
        return data.data;
    } catch (error) {
        throw new NrlkException(error);
    }
}


